/**
 * imageMIME.js
 * Talkroute
 *
 * Created by Vel Genov on 10/16/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * A list of image MIME types
 */
const imageMIME = {
  BMP: "image/bmp",
  JPEG: "image/jpeg",
  TIFF: "image/tiff",
  GIF: "image/gif",
  PNG: "image/png",
};

export default imageMIME;
